const createHistory = require("history").createBrowserHistory;
let publicUrl=process.env.publicUrl;
let obj={};
if(publicUrl!=="undefined"){
    obj.basename=publicUrl;
}
export default createHistory(obj);